import { useContext } from "react";
import { EntityDetailProps, EntityDetailTableProps } from "../common/entity/EntityInterfaces";
import { toUppercase } from "../common/helperfunctions/stringFunctions";
import { GetProjects } from "../common/misc/EntityRenders/EntityRenderer";
import { NotAvailable, NotSet } from "../common/misc/UIconstants";
import Detail from "../common/panels/Detail/Detail";
import { Table } from "../common/panels/Detail/DetailTable";
import { DetailsPageTopControlsView } from "../common/panels/misc/DetailsPageTopControlsView/DetailsPageTopControlsView";
import { DownloadDataset } from "../Dataset/common/DownloadDataset/DownloadDataset";
import { SessionContext } from "../common/contexts/SessionContext";
import { Files } from "../Dataset/tiles/Files/Files";
import { CustomFieldReferencesTile } from "../common/sidebar/tiles/CustomFieldReferencesTile";
import { Panel, PanelGroup } from "react-resizable-panels";
import { CustomResizeHandle } from "../common/panels/misc/CustomResizeHandle";
import { EntityRestoreButton } from "../common/entity/entityComponents/EntityRestoreButton";
import { EntityDeleteButton } from "../Entities/GenericComponents/common/GenericEntityDetailPage";
import { Viewer } from "../ViewerLayout/FullViewer";
import { EntityEditButton } from "../common/entity/entityComponents/EntityEditButton";

export const AttachmentsDetailTable = ({
  entity: dataset,
  entityConstants,
  fieldLabels,
}: EntityDetailTableProps<"attachments">) => {
  return (
    <>
      <Table noPadding nonFoldable>
        <Table.Head>Details</Table.Head>
        <Table.Body>
          <Table.Body.RowContent
            title={fieldLabels.name}
            content={
              <div className="container_label">
                <div className="container_label_name" style={{ fontWeight: 600 }}>
                  {dataset.name ?? NotSet}
                </div>
                <div className="container_label_id">
                  <span style={{ whiteSpace: "nowrap" }}>
                    {toUppercase(entityConstants.entitySingular)}-ID: {dataset.id ?? NotAvailable}
                  </span>
                </div>
              </div>
            }
          />
          <Table.Body.RowContent
            title={fieldLabels.projects}
            content={<GetProjects projects={dataset.projects} createLinks />}
          />
        </Table.Body>
      </Table>
    </>
  );
};

export const AttachmentsDetail = ({
  entity,
  entityApi,
  entityConstants,
  fieldLabels,
  permissions,
  routes,
  entityTypeId,
}: EntityDetailProps<"attachments">) => {
  const { api, session } = useContext(SessionContext);
  return (
    <Detail
      head={
        <DetailsPageTopControlsView
          entityTypeId={entityTypeId}
          entity={entity}
          entityConstants={entityConstants}
          controls={
            <>
              {!!entity.isDeleted ? (
                <EntityRestoreButton
                  entity={entity}
                  entityConstants={entityConstants}
                  entityApi={entityApi}
                  permissions={permissions}
                />
              ) : (
                <>
                  <DownloadDataset
                    btnStyle="btn btn-primary"
                    id={entity.id}
                    label={`Download ${entityConstants.entitySingular}`}
                    api={api}
                  />
                  {entity.viewableEntityType === "ELN" && (
                    <>
                      <EntityEditButton
                        entity={entity}
                        entityConstants={entityConstants}
                        permissions={permissions}
                        routes={routes}
                      />
                    </>
                  )}
                </>
              )}
            </>
          }
          controlsDropdown={
            <li>
              <EntityDeleteButton entity={entity} entityTypeId={entityTypeId} />
            </li>
          }
        />
      }
      // mainStyle={{ padding: "0px 10px" }}
      main={
        <div className="flex col-nowrap gap-5" style={{ width: "100%", height: "100%" }}>
          <PanelGroup direction="vertical">
            <Panel defaultSize={50} minSize={0} collapsible={true} style={{ padding: 5 }}>
              <Viewer
                ids={[entity.id]}
                settings={{
                  interactiveMode: true,
                  showParameter: true,
                  showNavigation: true,
                  showTrackList: true,
                }}
              />
            </Panel>
            <CustomResizeHandle orientation="vertical" />
            <Panel defaultSize={50} minSize={0} collapsible={true} style={{ padding: 1 }}>
              <Files dataset={entity} />
            </Panel>
          </PanelGroup>
        </div>
      }
      sidebar={
        <>
          <CustomFieldReferencesTile
            entityType="Attachment"
            entity={entity}
            labNotebookEntryFilters={session?.features.eln ? { attachmentReferenceIds: [entity.id] } : undefined}
          />
        </>
      }
    />
  );
};
